export default "__VITE_ASSET__3c36b82f__"